import './shared/utils/sentry';

import { StrictMode } from 'react';
import { isIOS, isMobileOnly } from 'react-device-detect';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import reportWebVitals from './reportWebVitals';

import './i18n';

import 'swiper/css/bundle';

import 'react-datepicker/dist/react-datepicker.css';

import './index.scss';

import { HelmetProvider } from 'react-helmet-async';

document.documentElement.classList.toggle('ios-phone', isIOS && isMobileOnly);

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
